import React from "react";
import { compose, withAppContext, withFarmContext } from "containers/HOC";
import Page from "components/Page";
import PageBody from "components/PageBody";
import NationalReporting from "../Admin/NationalReporting/NationalReporting";

const Benchmarking = ({ farm }) => {
    return (
        <Page>
            <PageBody>
                <NationalReporting farm={farm} />
            </PageBody>
        </Page>
    );
};

export default compose(withAppContext, withFarmContext)(Benchmarking);
